import script from "./BonusAccountPayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./BonusAccountPayment.vue?vue&type=script&setup=true&lang=ts"

import "./BonusAccountPayment.vue?vue&type=style&index=0&id=f3823b48&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3823b48"]])

export default __exports__